import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { AlertAction, CommonAction, CompanyAction, LicenseAction, ProductAction } from '../../actions';
import { ProductConstant } from '../../actions/constants/ProductConstant';
import { InputBasicText, InputSelect2 } from '../../components/common/Inputs';
import { Loading } from '../../components/common/Loading';
import { CTSegmentation, FaceAnalyzer, RAYFACE, SmartDentFiveD, TEMPS } from '../../config/RayCodes';
import { Translate as t } from '../../config/Translate';
import { isRootCompany } from '../../lib/licenseHelper';

const ProductChangeType = ({ user, product, UpdateProductInfo, GetCompanyInfo, company, products, siteProducts, GetProductBySiteId }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [prdTypes, setPrdTypes] = useState([{code: "normal", title: t('common.status.normal')}]);
  const [remainCount, setRemainCount] = useState(0);
  const [managedGroupInfo, setManagedGroupInfo] = useState({});
  const [transferData, setTransferData] = useState({
    prdtype: "",
    show: false,
  });
  const [originalLicenseSN, setOriginalLicenseSN] = useState({});
  const [siteProduct, setSiteProduct] = useState([]);
  const [selectedProductSN, setSelectedProductSN] = useState("");
  const [add5DCTData, setAdd5DCTData] = useState({
    show: false,
    reason: "",
  });
  const [replacementProductVerified, setReplacementProductVerified] = useState(false);
  // model: "RAYFace" 이면 expert
  // ct 장비 이면 5d
  useEffect(() => {
    if(product) {
      setData({
          sn: product?.sn,
          prdtype: product?.prdtype || "",
          reason: `${product?.sn} -> `,
          new_sn: "",
      })
      setTransferData({
          prdtype: "",
          show: false
      })
      getPrdType();
      GetCompanyInfo(product.companyId);
      GetProductBySiteId(product.siteId, "5d");
      (async () => {
        const ret = await LicenseAction.GetLicenseSN({sn: product.sn});
        if(ret) {
          if (ret.length > 1) {
            setOriginalLicenseSN(ret[0] ?? {});
          } else {
            setOriginalLicenseSN(ret ?? {});
          }
        }
      })();

    }
  }, [product]);

  useEffect(() => {
      if(siteProducts && product?.sn) {
        setSiteProduct(siteProducts.filter(item => item.siteId != "" && item.siteId == product.siteId  && item?.prdtype.toLowerCase() == "5d" && item.sn != product.sn));
      }
  }, [siteProducts]);

  useEffect(() => {
      if(company && company?._id) {
          getManagerGroupInfoByCompanyId();
      }
  }, [company]);

	const getPrdType = async () => {
		const res = await CommonAction.GetRecord({
			data : {
				type : "raycode",
				filter : {
                    type: 'PRDTYPE',
                    group: product?.model?.includes('RAYFace') ? 'RAYFace' : 'CT'
                },
			}
		});
		if(res?.data) {
			setPrdTypes( [{code: "normal", title: t('common.status.normal')}, ...res.data.map(item => {
				return { code: item.code, title: item.name }
			})]);
		}
	}

  const getManagerGroupInfoByCompanyId = async () => {
    //let companyId = (user?.companyId == "RAY00001" || user?.companyId == "RAY90046") ? user?.companyId : product.companyId;
    let companyId = user?.companyId;
    let managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(companyId, product?.model?.includes('RAYFace') ? 'App-FaceAnalyzer' : 'App-SmartDentFiveD');
    if(managerGroupInfo.length == 0) {
      const parentCompanyId = await CompanyAction.GetParents("");
      console.log("🚀 ~ getManagerGroupInfoByCompanyId ~ parentCompanyId:", parentCompanyId);
      if (parentCompanyId.length === 1 && parentCompanyId[0].code === companyId) {
        companyId = companyId;
      } else {
        companyId = parentCompanyId.find(x => x.code !== companyId && x?.org === "Branch" && isRootCompany(x))?.code;
      }
      managerGroupInfo = await LicenseAction.GetManagerGroupInfoByCompanyId(companyId, product?.model?.includes('RAYFace') ? 'App-FaceAnalyzer' : 'App-SmartDentFiveD');
    }

    setManagedGroupInfo(managerGroupInfo);
    const totalCount = managerGroupInfo?.t_package || 0;
    const useCount = managerGroupInfo?.u_package || 0;
    setRemainCount(totalCount - useCount);
  };

  const changeSn = async () => {
    try {
        setLoading(true);
        const licenseSN = await LicenseAction.GetLicenseSN({sn: product.sn});
        const pid = product?.model?.toUpperCase().includes(RAYFACE) ? FaceAnalyzer.pid : CTSegmentation.pid;
        if(data.prdtype == "normal") {
            if(licenseSN) {
                const allLicenseSN = await LicenseAction.GetALLLicenseSN({sn: product.sn});
                for(const item of allLicenseSN) {
                    await LicenseAction.UpdateLicenseSN({
                        _id: item._id,
                        sk: item.sk,
                    });
                }

                await LicenseAction.UpdateLicenseSN({
                    _id: product?.model?.toUpperCase().includes(RAYFACE) ? FaceAnalyzer.appId : CTSegmentation.appId,
                    sk: licenseSN.sk
                });
            }
        } else {
          if(licenseSN.length == 0 && product?.model?.toUpperCase().includes(RAYFACE) && product?.sn) {
            const checkFireStoreSN = await LicenseAction.CheckFireStoreSN(product.sn);
            let updateParams = {};
            if(!checkFireStoreSN) {
              updateParams = {
                sn: product.sn,
                appId: FaceAnalyzer.appId,
                lcType: "package",
                created: Date.now(),
                creator: user?._id || "",
                groupId: TEMPS.TEMPGroup,
                ntid: TEMPS.TEMPNtId,
                mgroupid: managedGroupInfo?.sk?.split(":")[1] || TEMPS.TEMPMGroupId,
                userId: TEMPS.TEMPUser,
                pid: pid
              }
            } else {
              updateParams = {
                sn: product.sn,
                appId: FaceAnalyzer.appId,
                lcType: "package",
                created: Date.now(),
                creator: user?._id || "",
                groupId: checkFireStoreSN?.groupId || TEMPS.TEMPGroup,
                ntid: checkFireStoreSN?.networkId || TEMPS.TEMPNtId,
                mgroupid: managedGroupInfo?.sk?.split(":")[1] || TEMPS.TEMPMGroupId,
                userId: TEMPS.TEMPUser,
                pid: pid
              };
            }
            const licenseSN = await LicenseAction.CreateLicenseSN(updateParams);
          }
          //#region CT Segmentation 라이센스 생성 주석처리 2025.05.22 - 해당 라이선스는 5D Installer 에서만 생성 한다.
          // else {
          //     if(licenseSN.length == 0 && user?.companyId == "RAY90001") {
          //         console.log("CheckFireStoreSN start");
          //         const checkFireStoreSN = await LicenseAction.CheckFireStoreSN(product.sn);
          //         let updateParams = {};
          //         if(!checkFireStoreSN) {
          //             updateParams = {
          //                 sn: product.sn,
          //                 appId: 'App-CTSegmentation',
          //                 lcType: "package",
          //                 created: Date.now(),
          //                 creator: user?._id || "",
          //                 groupId: "tempgroup",
          //                 ntid: "tempntid",
          //                 mgroupid: managedGroupInfo?.sk?.split(":")[1] || "tempgroupid",
          //                 userId: "tempuser",
          //                 pid: pid
          //             }
          //         } else {
          //             updateParams = {
          //                 sn: product.sn,
          //                 appId: 'App-CTSegmentation',
          //                 lcType: "package",
          //                 created: Date.now(),
          //                 creator: user?._id || "",
          //                 groupId: checkFireStoreSN?.groupId || "tempgroup",
          //                 ntid: checkFireStoreSN?.networkId || "tempntid",
          //                 mgroupid: managedGroupInfo?.sk?.split(":")[1] || "tempgroupid",
          //                 userId: "tempuser",
          //                 pid: pid
          //             };
          //         }
          //         console.log("updateParams======================", updateParams);
          //         const licenseSN = await LicenseAction.CreateReluLicenseSN(updateParams);
          //     }
          // }
          //#endregion

          await LicenseAction.UpdateLicenseCount({
            appid: product?.model?.includes('RAYFace') ? FaceAnalyzer.appId : SmartDentFiveD.appId,
            mgroupid: managedGroupInfo?.sk?.split(":")[1]
          });
        }

        const ret = await UpdateProductInfo(product._id, {
            prdtype: data.prdtype === "normal" ? "" : data.prdtype
        });
        console.log('=====================ret========================', ret);

      } catch (error) {
        console.log("changeSn : error", error);
      } finally {
        setLoading(false);
      }
    }

    const transferProductLicense = async () => {
        if(transferData.show) {
            setTransferData({
                show: false,
            });
            setReplacementProductVerified(false);

            return;
        }
        setTransferData({
            show: true,
        });
        setReplacementProductVerified(false);

        const ret = await LicenseAction.GetLicenseSN({sn: product.sn});
        setOriginalLicenseSN(ret);

    };

    const verifyReplacementProduct = async () => {
        try {
            setLoading(true);
            const result = await ProductAction.GetProductBySN(data.new_sn);
            if (result && result.sn) {
                // Product found - add SN to Reason and enable button
                const currentReason = data.reason.trim() || `${data.sn} -> `;
                const updatedReason = `${currentReason}${data.new_sn}`;
                setData({
                    ...data,
                    reason: updatedReason
                });
                setReplacementProductVerified(true);
            } else {
                // Product not found - keep button disabled
                setReplacementProductVerified(false);
            }
        } catch (error) {
            console.log("verifyReplacementProduct : error", error);
            setReplacementProductVerified(false);
        } finally {
            setLoading(false);
        }
    };

    const changeProductType = async () => {
        try {
            setLoading(true);
            dispatch({ type: ProductConstant.LOADING });
            const originData = {
                sn: data.sn,
                prdtype: "normal",
                reason: data.reason,
                user: user?._id
            }
            const licenseSN = await LicenseAction.ProductChangeSN(originData);
            const newData = {
                sn: data.new_sn,
                prdtype: data.prdtype,
                reason: data.reason,
                user: user?._id
            };
            const newLicenseSN = await LicenseAction.ProductChangeSN(newData);
            const changeLicenseSN = await LicenseAction.ChangeLicenseSN(originalLicenseSN, newData);
            dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: licenseSN.data });
            dispatch({ type: ProductConstant.LOADED });
            dispatch(AlertAction.Success(t('common.message.success.saved')));


            setLoading(false);
        } catch (error) {
            console.log("🚀 ~ changeProductType ~ error:", error);
            dispatch({ type: ProductConstant.LOADED });
            setLoading(false);
        }
    };

    const addTo5DCT = async () => {
      try {
        setLoading(true);
        const date = Date.now();
        const ret = await LicenseAction.GetALLLicenseSN({sn: selectedProductSN});
        const selectedProductInfo = ret.filter(item => item.expired > date)[0];
        const createParams = {
          sn: product.sn,
          appId: selectedProductInfo?._id || "App-CTSegmentation",
          lctype: 'package',
          creator: user?._id || "",
          created: Date.now(),
          groupId: selectedProductInfo?.groupid || "tempgroup",
          ntid: selectedProductInfo?.ntid || "tempntid",
          pid: selectedProductInfo?.pid || "temppid",
          userId: "tempuser"
        };
        // CreateReluLicenseSN 은 실패를 삼키고 null 을 반환한다 — 체인 끝의 성공 안내 판정에 쓴다.
        const reluRet = await LicenseAction.CreateReluLicenseSN(createParams, product);
        const newData = {
          sn: product.sn,
          prdtype: "5d",
          reason: add5DCTData.reason,
          user: user?._id,
          type: "reason"
        };
        const newLicenseSN = await LicenseAction.ProductChangeSN(newData);
        dispatch({ type: ProductConstant.UPDATE_PRODUCTINFO, product: newLicenseSN.data });
        dispatch({ type: ProductConstant.LOADED });
        if (reluRet) dispatch(AlertAction.Success(t('common.message.success.saved')));
        setSelectedProductSN("");
        setAdd5DCTData({show: false, reason: ""});
      } catch (error) {
        // IMP-091 §7: addTo5DCT 실패 관측 + 로딩 해제(스피너 영구 방지)
        console.warn('[ProductChangeType.addTo5DCT] failed', {
          handler: 'ProductChangeType.addTo5DCT',
          target: product?.sn,
          reason: error?.message || String(error),
        });
        dispatch(AlertAction.ErrorMsg(t('product.message.changeTypeFailed')));
        dispatch({ type: ProductConstant.LOADED });
      } finally {
        setLoading(false);
      }
    };

    return (
        <>
            {product && (
                <>
                    <div className="section mt-2 mb-2">
                        <div className="card bg-danger text-white">
                            <div className="card-header d-flex justify-content-between">
                                <div className="card-title">{t('common.label.warning')}</div>
                                <div className="card-text text-white">{t('product.changeType.licenseRemaining').replace('{count}', remainCount)}</div>
                            </div>
                            <div className="card-body">
                                <h4 className="text-white">{t('product.updateSite.appliedImmediately')}</h4>
                                <div className="text-white">
                                    <p className="text-white">{t('product.confirm.irreversible')} {t('product.changeType.typeChangeNote')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {product.siteId && (
                        <ProductInfoSite product={product} showtitle={false} />
                    )} */}
                    <div className="section mt-2 mb-2">
                        <div className="card">
                            <div className="card-body">
                                <InputSelect2
                                    options={{
                                        name: "prdType",
                                        label: t('product.field.productType'),
                                        val: data.prdtype,
                                        list: prdTypes,
                                        disabled: transferData.show
                                    }}
                                    onchange={(e) => setData({ ...data, prdtype: e.target.value })}
                                    editable={true} />
                            </div>
                        </div>
                        {loading && <Loading />}
                        {!loading && user.adminType != 'U' &&
                          user.isTypeChange &&
                          (remainCount > 0) &&
                          !transferData.show &&
                        <button className={`btn btn-outline-danger ${!(data.prdtype) || (originalLicenseSN?._id && data.prdtype != 'normal') ? 'disabled' : ''}`} onClick={() => changeSn()}>{t('common.button.changeType')}</button>
                        }
                        {!loading && user?.isProductChange &&
                        (product?.prdtype == 'expert' || product?.prdtype == '5d') &&
                        <button className={`btn btn-outline-primary ms-2 ${!(product?.prdtype) || product?.prdtype == "normal" ? 'disabled' : ''}`}
                        onClick={() => transferProductLicense()}>{t('product.button.equipmentReplacement')}</button>
                        }
                    </div>
                    {siteProduct.length > 0 && user.adminType == 'S' && user?.isAddProductSite && (
                      <>
                      <div className="section mt-2 mb-2">
                        <div className="card bg-secondary text-white">
                          <div className="card-header d-flex justify-content-between">
                            <div className="card-title">{t('product.changeType.installed5dDevice').replace('{sitename}', siteProduct[0].sitename)}</div>
                          </div>
                            {siteProduct.map((item) => (
                              <div className={`card-body ${selectedProductSN === item.sn ? 'bg-primary text-white rounded-bottom' : ''}`}>
                                <div className="d-flex justify-content-between align-items-center">
                                  <h4 className="text-white mb-0">{`[${item.sn}]  -  ${item.model} ${item.option}`}</h4>
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`check-${item.sn}`}
                                      checked={selectedProductSN === item.sn}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setSelectedProductSN(item.sn);
                                          setAdd5DCTData({show: true, reason: ""});
                                        } else {
                                          setSelectedProductSN("");
                                          setAdd5DCTData({show: false, reason: ""});
                                        }
                                      }}
                                    />
                                    <label className="form-check-label text-white" htmlFor={`check-${item.sn}`}>{t('common.button.select')}</label>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                        {loading && <Loading />}
                      </div>
                      </>
                    )}

                    {transferData.show && (<>
                    <div className="section mt-2 mb-2">
                      <div className="card bg-danger text-white">
                        <div className="card-header d-flex justify-content-between">
                          <div className="card-title">{t('common.label.warning')}</div>
                        </div>
                        <div className="card-body">
                          <h4 className="text-white">{t('product.updateSite.appliedImmediately')}</h4>
                          <div className="text-white">
                            <p className="text-white">{t('product.changeType.transferTypeNote')}</p>
                            <p className="text-white">{t('product.changeType.transferLicenseNote')}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="section mt-2 mb-2">
                        <div className="card">
                            <div className="card-body">
                                <InputBasicText
                                    options={{
                                        name: 'new_sn',
                                        label: t('product.field.sn'),
                                        val: data.new_sn,
                                        required: true
                                    }}
                                    onchange={(e) => {
                                        setData({
                                            ...data,
                                            new_sn: e.target.value.toUpperCase()
                                        });
                                        setReplacementProductVerified(false);
                                    }}
                                    editable={true} />
                                <InputBasicText
                                    options={{
                                        name: 'reason',
                                        label: t('common.field.reason'),
                                        val: `${data.reason}`,
                                        required: true
                                    }}
                                    onchange={(e) => setData({ ...data, reason: e.target.value})}
                                    editable={true} />
                            </div>
                        </div>
                        {loading && <Loading />}
                        {!loading && (
                            <>
                                {data.new_sn && data.new_sn.trim() && (
                                    <button
                                        className="btn btn-outline-primary me-2"
                                        onClick={() => verifyReplacementProduct()}
                                    >
                                        {t('product.button.verifyReplacement')}
                                    </button>
                                )}
                                <button
                                    className={`btn btn-outline-secondary ${!(data.prdtype) || !(data.new_sn) || !(data.reason) || data.new_sn == data.sn || !replacementProductVerified ? 'disabled' : ''}`}
                                    onClick={() => changeProductType()}
                                >
                                    {t('product.message.changeTypeProceed')}
                                </button>
                            </>
                        )}
                    </div>
                    </>
                    )}

                    {add5DCTData.show && !originalLicenseSN?._id && user?.isAddProductSite && (<>
                    <div className="section mt-2 mb-2">
                      <div className="card bg-danger text-white">
                        <div className="card-header d-flex justify-content-between">
                          <div className="card-title">{t('common.label.warning')}</div>
                        </div>
                        <div className="card-body">
                          <h4 className="text-white">{t('product.updateSite.appliedImmediately')}</h4>
                          <div className="text-white">
                            <p className="text-white">{t('product.changeType.addToSiteNote')}</p>
                            <p className="text-white">{t('product.changeType.grantCtSegNote')}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="section mt-2 mb-2">
                        <div className="card">
                            <div className="card-body">
                                <InputBasicText
                                    options={{
                                        name: 'reason',
                                        label: t('common.field.reason'),
                                        val: `${add5DCTData.reason}`,
                                        required: true
                                    }}
                                    onchange={(e) => setAdd5DCTData({ ...add5DCTData, reason: e.target.value})}
                                    editable={true} />
                            </div>
                        </div>
                        {loading && <Loading />}
                        {!loading && <button className={`btn btn-outline-secondary ${!(add5DCTData.reason) ? 'disabled' : ''}`}
                        onClick={() => addTo5DCT()}>{t('product.message.addProceed')}</button>}
                    </div>
                    </>
                    )}

                </>
            )}
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.ProductReducer.isUpdateRes;
    const user = state.AuthReducer.user;
    const company = state.CompanyReducer.company;
    const product = state.ProductReducer.product;
    const products = state.ProductReducer.products;
    const siteProducts = state.ProductReducer.siteProducts;
    return { user, isUpdateRes, company, product, products, siteProducts };
}

const mapDispatch = dispatch => ({
    GetCompanyInfo: (companyId) => dispatch(CompanyAction.GetCompanyInfo(companyId)),
    UpdateProductInfo: (_id, data) => dispatch(ProductAction.UpdateProductInfo(_id, data)),
    GetProductBySiteId: (siteId, prdtype) => dispatch(ProductAction.GetProductBySiteId(siteId, prdtype)),
})

export default connect(mapState, mapDispatch)(ProductChangeType);
